<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="代金券" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div v-if="vouchertemplate.vouchertemplate_creator_id>0">
        	<div class="vouchertemplate-wrapper">
        		<img class="img top" src="../../../assets/image/member/vouchertemplate-top.png" />
        		<img class="img bottom" src="../../../assets/image/member/vouchertemplate-bottom.png" />
        		<div class="div vouchertemplate-info">
        			<div class="div storename" >{{vouchertemplate.vouchertemplate_storename}}商品代金券</div>
        			<div class="div time"><span class="left"></span><span class="middle"></span>有效期{{vouchertemplate.vouchertemplate_startdate}}-{{vouchertemplate.vouchertemplate_enddate}}<span class="right"></span></div>
        			<div class="div price-wrapper">
        				<div class="price">
        					￥<span class="number">{{vouchertemplate.vouchertemplate_price}}</span>
        					<div class="p">满{{vouchertemplate.vouchertemplate_limit}}元使用</div>
        				</div>
        				<div class="store-img">
        					<img class="img" src="../../../assets/image/member/vouchertemplate-store.png" />
        				</div>
        			</div>
        		</div>
        	</div>
        	<div class="btn-wrapper" v-if='state == 0'><div class="div common-btn"  @click="exchangeVoucher(vouchertemplate)">确认领取</div></div>
        	<div class="btn-wrapper" v-else><div class="div common-btn"  @click="goProduct(vouchertemplate.vouchertemplate_store_id)">领取成功,去使用</div></div>
        </div>
        <div class="div"  v-else>
        	<empty-record></empty-record>
        </div>
    </div>
</template>

<script>
import { getVoucherPrivate } from '../../../api/memberVoucher'
import { exchangePointVoucher } from '../../../api/homePointsgoods'
import { Toast, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { mapState } from 'vuex'
export default {
  name: 'MemberVoucherPrivate',
  components: {
    EmptyRecord
  },
  data () {
    return {
     navHeight: 0,
     vouchertemplate_id:0,
     vouchertemplate:{},
     state:0
    }
  },
  computed: {
    ...mapState({
      token: state => state.member.token
    })
  },
  created () {
	this.vouchertemplate_id = this.$route.query.id
	this.getVoucherPrivate()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
	goProduct (id) {
	  this.$router.push({ 'name': 'HomeStoreGoodslist', 'query': { id: id} })
	},
	exchangeVoucher (vouchertemplate) {
	  MessageBox.confirm('您确定需要使用' + vouchertemplate.vouchertemplate_points + '积分兑换代金券吗？', '').then(action => {
	    exchangePointVoucher({ vid: vouchertemplate.vouchertemplate_id, key: this.token }).then(res => {
	      Toast(res.message)
		  this.state = 1
	    }).catch(error => {
	      Toast(error.message)
	    })
	  }).catch(error => {
	
	  })
	},
	getVoucherPrivate () {
	  getVoucherPrivate(this.vouchertemplate_id).then(res => {
		this.vouchertemplate = res.result.vouchertemplate_info
	  }).catch(function (error) {
	    Toast(error.message)
	  })
	}
  }
}
</script>

<style scoped lang="scss">
.vouchertemplate-wrapper{
	background-color: #e6a117;
	position: relative;
	padding: 1rem $pageSpace;
	color: #fff;
	display: flex;
	justify-content: center;
	margin: .9rem;
	.img{
		position: absolute;
		width: 100%;
		height: .15rem;
		object-fit: cover;
	}
	.top{
		top: 0;
		left: 0;
	}
	.bottom{
		left: 0;
		bottom: 0;
	}
	.vouchertemplate-info{
		font-size: .7rem;
		.storename{
			text-align: center;
		}
		.time{
			display: flex;
			align-items: center;
			height: .8rem;
			margin-top: .7rem;
			.left{
				width: 2rem;
				height: 1px;
				background-color: rgba(255,255,255,.2);
				flex: 1 1 0%;
				margin-right: 1rem;
			}
			.right{
				width: 2rem;
				height: 1px;
				background-color: rgba(255,255,255,.2);
				flex: 1 1 0%;
				margin-left: 1rem;
			}
		}
		.price-wrapper{
			padding-top: 1rem;
			display: flex;
			.price{
				font-size: .9rem;
				.number{
					font-size: 1.9rem;
				}
				.p{
					font-size: .7rem;
				}
			}
			.store-img{
				width: 4.5rem;
				height: 4.5rem;
				margin-left: auto;
				margin-top: -1rem;
				.img{
					width: 4.5rem;
					height: 4.5rem;
				}
			}
		}
	}
}
.btn-wrapper{
	margin-top: 1rem;
	margin: 0 .8rem;
	.common-btn{
		background-image: linear-gradient(to right, rgb(255, 144, 0), rgb(255, 80, 0));
		color: #fff;
		font-size: .8rem;
		padding: .5rem 0;
		border-radius: .5rem;
		width: 100%;
	}
}
</style>

